
// 后端返回的文件流，表格下载（请求参数后添加 responseType: "blob"
// res返回的文件流 ，name下载的文件名，type下载的文件类型(例如：docx、excel、png)
function exportData(res,name,type) {
  const blob = new Blob([res.data], {
    type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });
  const a = document.createElement("a");
  // 生成文件路径
  let href = window.URL.createObjectURL(blob);
  a.href = href;
  a.download = name+type;
  // 利用a标签做下载
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(href);
  
}
export default exportData